import PropTypes from "prop-types";

const Row = ({ label, value }) =>
  value ? (
    <div className="c4prf__sum-row">
      <dt>{label}</dt>
      <dd>{value}</dd>
    </div>
  ) : null;

Row.propTypes = { label: PropTypes.string, value: PropTypes.node };

/* The stored account record, read straight from getUserProfile. */
const AccountSummary = ({ user, since }) => (
  <dl className="c4prf__sum">
    <Row label="Name" value={user?.name} />
    <Row label="Email" value={user?.email} />
    <Row label="Phone" value={user?.phoneNumber} />
    <Row
      label="Location"
      value={[user?.city, user?.state, user?.country].filter(Boolean).join(", ")}
    />
    <Row label="Member since" value={since} />
  </dl>
);

AccountSummary.propTypes = {
  user: PropTypes.object,
  since: PropTypes.string,
};

export default AccountSummary;
